// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"DM","errorHeading":"EM"};